import { Order } from "../../../services";
import { DateRange, DateRangeLiteral } from "../../../types/DataRange";
import archiveReportsByOrders from "../../reducers/Archives/Reports/charts/byOrders";

interface Options {
	taxiServiceIds?: number[];
	dateRange: DateRange | DateRangeLiteral;
}

export default function getArchiveOrdersForChart(options: Options) {
	return async (dispatch) => {
		dispatch(archiveReportsByOrders.actions.setLoading(true));

		const requestParams = {
			sanitizeType: "dispatcher_front_order_archive",
			taxiServiceIds: options?.taxiServiceIds || [],
			dateRange: {
				from: new Date(options.dateRange.from),
				to: new Date(options.dateRange.to),
			},
		} as Order.SubscribeOptions;

		const activeTab = "overall";
		const data = await Order.getByTab(activeTab, requestParams);

		if (data) {
			dispatch(
				archiveReportsByOrders.actions.setDateRange(options.dateRange),
			);
			dispatch(
				archiveReportsByOrders.actions.determineInterval(
					options.dateRange,
				),
			);
			dispatch(archiveReportsByOrders.actions.setOrders(data.items));
		}
		dispatch(archiveReportsByOrders.actions.setLoading(false));
	};
}
